// @mui
import { Box, List } from '@mui/material';
import { useSelector } from 'react-redux';
import useLocales from 'src/common/hooks/useLocales';
import { useGetGroupPolicesUser } from '../../../../auth/login/hook/useGetGroupPoliciesUser';
import { rulesSelector } from '../../../../auth/login/login.slice';
import { NavSectionProps } from '../type';
import NavList from './NavList';
import { ListSubheaderStyle } from './style';

// ----------------------------------------------------------------------

export default function NavSectionVertical({
  navConfig,
  isCollapse,
  ...other
}: NavSectionProps) {
  const { translate } = useLocales();
  const rules = useSelector(rulesSelector);

  const { data: policies } = useGetGroupPolicesUser();

  const listPolicies = [] as any[];

  policies?.groupPolicies?.forEach((item: any) => {
    item.policies?.forEach((policy: any) => {
      if (!listPolicies.includes(policy)) {
        listPolicies.push(policy);
      }
    });
  });

  const isRootAccount = listPolicies?.find((item: any) => {
    return (
      item.action === 'manage' && item.actionAbility === 'can' && item.resource === 'all'
    );
  });

  return (
    <Box {...other}>
      {navConfig.map((group) => {
        return (
          <List key={group.subheader} disablePadding sx={{ px: 2 }}>
            <ListSubheaderStyle
              sx={{
                ...(isCollapse && {
                  opacity: 0,
                }),
              }}
            >
              {translate(group.subheader)}
            </ListSubheaderStyle>

            {isRootAccount
              ? group.items.map((list) => (
                  <NavList
                    key={list.title + list.path}
                    data={list}
                    depth={1}
                    hasChildren={!!list.children}
                    isCollapse={isCollapse}
                  />
                ))
              : group.items.map((list, index) => {
                  const can = listPolicies?.find((item: any) => {
                    return (
                      item.actionAbility === 'can' && item.resource === list?.resource
                    );
                  });
                  if (can) {
                    return (
                      <NavList
                        key={list.title + list.path}
                        data={list}
                        depth={1}
                        hasChildren={!!list.children}
                        isCollapse={isCollapse}
                      />
                    );
                  }
                })}
          </List>
        );
      })}
    </Box>
  );
}
